import { createFileRoute, redirect } from '@tanstack/react-router'
import { PlatformLayout } from '@/layouts/PlatformLayout'
import { useAuthStore } from '@/store/auth.store'

export const Route = createFileRoute('/_platform')({
  beforeLoad: () => {
    const user = useAuthStore.getState().user
    if (!user?.is_platform_staff && !user?.is_superuser) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: PlatformLayout,
})
